import { render } from "./ButtonUserAndRole.vue?vue&type=template&id=38190b30"
import script from "./ButtonUserAndRole.vue?vue&type=script&lang=js"
export * from "./ButtonUserAndRole.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__